
import Printer from '../../Model/Printer';
import BaseFirebaseRepository from './BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()

const DEVICE_CUSTOM_PRINTER_TYPES = {
    58: 'Custom 58mm',
    80: 'Custom 80mm',
};
export default class PrinterRepository extends BaseFirebaseRepository {
    isUseAPI = true

    /**
     * @param {*} app
     * @return {PrinterRepository}
     */
    static getInstance(app, isLoadByFirebase) {
        if (app == null) {
            // By default, use instance created from main App
            app = PrinterRepository.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new PrinterRepository(app)
            instances[app].isUseAPI = !isLoadByFirebase
        }
        return instances[app]
    }

    /**
     * Once we get the result from Firebase, will use this to preprocess the
     * data before pass assign the data to getBaseObject()
     */
     preprocessItem = (p) => {
        p = Printer.dtoFromServer(p)
        if (p.is_main_printer && (!p.merchant_printers || p.merchant_printers.length == 0)) {
            // Is main printer, but not specifically added as merchant_printer,
            // we just name it as "Main Printer"
            p.merchant_printers = [
                {
                    id: null,
                    name: "Main Printer",
                }
            ]
        }
        return p
    }

    getBaseObject = () => {
        return {}
    }

    reloadDataEventThrottleTime = () => {
        return 5000
    }

    getReloadEventKey = () => {
        return "printers.changed"
    }

    getApiBaseUrl = (id) => {
        if (id && id !== 'all') {
            return `/merchant/api/printer/${id}`
        }
        return '/merchant/api/printer'
    }

    getPrinterStatus = () => {
        if (this.autoAbort) {
            this.abort()
        }
        let url = `/merchant/api/printer/status`
        this.request = $.ajax({
            type: "GET",
            url: url
        })
        return this.request
    }
    updatePrinterManagerApi = (deviceId) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchant/api/printer/set_printer_manager`,
                type    : 'post',
                data    : {
                    // deviceId = null then will remove ALL printer manager
                    device_id: deviceId,
                },
                success : (res) => {
                    resolve()
                }
            })
            .fail(() => {
                reject()
            })
            .always(() => {})
        })
    }
    setDeviceAsPrinterManager = (deviceId) => {
        return this.updatePrinterManagerApi(deviceId)
    }
    removeDeviceAsPrinterHandler = () => {
        return this.updatePrinterManagerApi(null)
    }
    setMainPrinter = (printerId) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : this.getApiUrl(printerId) + `/set_main_printer`,
                type    : 'post',
                success : (res) => {
                    resolve()
                }
            })
            .fail(() => {
                reject()
            })
            .always(() => {})
        })
    }
    setCustomPrinterAsMainPrinter = ({paperSize}) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchant/api/printer/set_custom_receipt_printer_as_main_printer`,
                type    : 'post',
                data    : {
                    type: DEVICE_CUSTOM_PRINTER_TYPES[paperSize]
                },
                success : (res) => {
                    resolve()
                }
            })
            .fail(() => {
                reject()
            })
            .always(() => {})
        })
    }

    /**
     * This function shall only be used when running app on Sunmi device,
     * where the device is 'activated' to be used a printer to print cashier/kitchen receipt
     */
    addSunmiPrinter = (sunmiPrinter) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchant/api/printer/add_sunmi_printer`,
                type    : 'post',
                data    : sunmiPrinter,
                success : (printer) => {
                    resolve(printer)
                }
            })
            .fail(() => {
                reject()
            })
        })
    }

    checkSunmiDevicePrinterAdded = (sunmiPrinter) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchant/api/printer/check_sunmi_printer_registered`,
                type    : 'post',
                data    : {
                    serial_number: sunmiPrinter.serialNumber,
                    model: sunmiPrinter.model,
                },
                success : (printer) => {
                    resolve(printer)
                }
            })
            .fail(() => {
                reject("checkSunmiDevicePrinterAdded API fail")
            })
        })
    }
}